import { render, staticRenderFns } from "./BrandSelection.vue?vue&type=template&id=23e22cdc&scoped=true&"
import script from "./BrandSelection.vue?vue&type=script&lang=js&"
export * from "./BrandSelection.vue?vue&type=script&lang=js&"
import style0 from "./BrandSelection.vue?vue&type=style&index=0&id=23e22cdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e22cdc",
  null
  
)

export default component.exports